import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { CblcType } from '../../enum/clbc-type.enum';

@Component({
    selector: 'select-account',
    templateUrl: './select-account.component.html',
    styleUrls: ['./select-account.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectAccountComponent {

    @Input()
    public accounts: any[];

    @Output() public cancelled: EventEmitter<any> = new EventEmitter();

    @Output() public accountSelected: EventEmitter<string> = new EventEmitter();

    public get personalAccounts() {
        return this.accounts
            .filter((a) => CblcType.Owner === a.CblcType);
    }

    public get otherAccounts() {
        return this.accounts.filter((a) => CblcType.Owner !== a.CblcType);
    }

    public selectAccount(code: string) {
        this.accountSelected.emit(code);
    }

    public cancelAccountSelect() {
        this.cancelled.emit(true);
    }

}
